module.exports = __webpack_public_path__ + "static/media/hiw8.e3752395.svg";